import React from "react";

import ContentCard from "../../../../components/misc/ContentCard";
import Text from "../../../../styleguide/Text";
import { dateToString } from "../../../../utils/dateAndTime";
import CustomButton from "../../../../components/CustomButton";
import { getDownloadProductHistory } from "../../../../redux/api/reports.api";
import { useAppDispatch } from "../../../../redux/hooks";

function ProductHeaderTable({
  codProdus,
  lot,
  dataExpirare,
  numeProdusErp,
  furnizor,
}: {
  codProdus: string;
  lot: string;
  dataExpirare: string;
  numeProdusErp: string;
  furnizor: string;
}) {
  const dispatch = useAppDispatch();

  const exportRaport = async () => {
    await dispatch(
      getDownloadProductHistory({
        codProdus: codProdus,
        dataExpirare: dataExpirare,
        lot: lot,
      }),
    );
  };
  return (
    <ContentCard>
      <div className="flex justify-between mb-6">
        <Text
          variant="h3"
          component="h3"
          className="font-semibold text-slate-900 mb-4"
          gutterBottom>
          Istoric produs
        </Text>
        <CustomButton
          variant="contained"
          withConfirmationModal={{
            modalTitle: "Exporta raport",
            modalSubtitle: "Esti sigur ca vrei sa exporti raportul?",
            modalLeftButtonText: "Anuleaza",
            modalLeftButtonVariant: "outlined",
            modalRightButtonText: "Exporta",
            modalRightButtonOnClick: exportRaport,
          }}>
          Exporta raport
        </CustomButton>
      </div>
      <table className="w-full border-collapse align-middle gap-0 gy-4 hover:bg-surface-hover">
        <thead>
          <tr className="font-semibold text-muted bg-surface-subtle">
            <th className="pl-3 rounded-l-control">
              <Text isBold>Denumire produs</Text>
            </th>
            <th>
              <Text isBold>Furnizor</Text>
            </th>
            <th>
              <Text isBold>Lot</Text>
            </th>
            <th>
              <Text isBold>Cod produs</Text>
            </th>
            <th className="pl-3 rounded-r-control">
              <Text isBold>Data expirare</Text>
            </th>
          </tr>
        </thead>
        <tbody className="font-semibold">
          <tr>
            <td>{numeProdusErp}</td>
            <td>{furnizor}</td>
            <td>{lot}</td>
            <td>{codProdus}</td>
            <td>{dateToString(dataExpirare)}</td>
          </tr>
        </tbody>
      </table>
    </ContentCard>
  );
}

export default ProductHeaderTable;
